export const siteSettings = {
  name: "Global Elite Markets",
  link: "https://globalelitemarkets.net",
  email: "support@globalelitemarkets.net",
  appLink: "https://app.globalelitemarkets.net",
};
